import { format, isAfter, subMonths } from 'date-fns';
class Utils {
  zeroPad = (num, places) => {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  }    
  cpfOuCnpj = (input) => {
    if (input !== undefined && input !== null) {
      input = '' + input;
      if (input.length <= 11) {
        return this.cpf(input);
      } else {
        return this.cnpj(input);
      }
    }
  }
  cnpj = (input) => {
    input = this.pad(input, 14);
    var str = input + '';
    str = str.replace(/\D/g, '');
    str = str.replace(/^(\d{2})(\d)/, '$1.$2');
    str = str.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    str = str.replace(/\.(\d{3})(\d)/, '.$1/$2');
    str = str.replace(/(\d{4})(\d)/, '$1-$2');
    return str;
  }
  cpf = (input) => {
    input = this.pad(input, 11);
    var str = input + '';
    str = str.replace(/\D/g, '');
    str = str.replace(/(\d{3})(\d)/, '$1.$2');
    str = str.replace(/(\d{3})(\d)/, '$1.$2');
    str = str.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return str;
  }
  pad = (n, width, z) => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
  formatCNPJTextField = (input, previousValue) => {
    input = input.replace(/[^\d.-/-]/g, '');
    if (input.length >= 2 && previousValue === '') {
      input = this.cnpj(input);
      return input;
    }
    if (input.length === 2 && previousValue.length < 2) {
      input = input + '.';
    }
    if (input.length === 6 && previousValue.length < 6) {
      input = input + '.';
    }
    if (input.length === 10 && previousValue.length < 10) {
      input = input + '/';
    }
    if (input.length === 15 && previousValue.length < 15) {
      input = input + '-';
    }
    if (input.length > 18 && input.length <= 19) {
      input = input.substring(0, 18);
    }
    if (input.length >= 14 && previousValue === '') {
      input = this.cnpj(input.substring(0, 14));
    }
    if (input.length >= 20) {
      input = this.cnpj(input.substring(0, 14));
    }
    return input;
  }
  formatCPFTextField = (input, previousValue) => {
    input = input.replace(/[^\d.-/-]/g, '');
    if (input.length >= 2 && previousValue === '') {
      input = this.cpf(input.substring(0, 11));
      return input;
    }
    if (input.length >= 16) {
      input = this.cpf(input.substring(0, 11));
      return input;
    }
    if (input.length === 3 && previousValue.length < 3) {
      input = input + '.';
    }
    if (input.length === 7 && previousValue.length < 7) {
      input = input + '.';
    }
    if (input.length === 11 && previousValue.length < 11) {
      input = input + '-';
    }
    if (input.length > 14 && input.length <= 15) {
      input = input.substring(0, 14);
    }
    return input;
  }
  formataValor = (input, previousValue) => {
    var valorRetorno;
    var valorFormatado = input.toString().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace('.', '');
    var length = valorFormatado.length;

    if (length >= 11) {
      valorFormatado = valorFormatado.substring(0, 11);
    }
    if (length >= 2 && previousValue === '') {
      valorFormatado = valorFormatado.substring(0, 11);
    }
    if (length >= 1 && length <= 2) {
      valorRetorno = valorFormatado;
    } else if (length === 3) {
      valorRetorno = valorFormatado.substring(0, 1) + ',' + valorFormatado.substring(1, 3);
    } else if (length === 4) {
      valorRetorno = valorFormatado.substring(0, 2) + ',' + valorFormatado.substring(2, 5);
    } else if (length === 5) {
      valorRetorno = valorFormatado.substring(0, 3) + ',' + valorFormatado.substring(3, 6);
    } else if (length === 6) {
      valorRetorno = valorFormatado.substring(0, 1) + '.' + valorFormatado.substring(1, 4) + ',' + valorFormatado.substring(4, 7);
    } else if (length === 7) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 5) + ',' + valorFormatado.substring(5, 8);
    } else if (length === 8) {
      valorRetorno = valorFormatado.substring(0, 3) + '.' + valorFormatado.substring(3, 6) + ',' + valorFormatado.substring(6, 9);
    } else if (length === 9) {
      valorRetorno = valorFormatado.substring(0, 1) + '.' + valorFormatado.substring(1, 4) + '.' + valorFormatado.substring(4, 7) + ',' + valorFormatado.substring(7, 10);
    } else if (length === 10) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 5) + '.' + valorFormatado.substring(5, 8) + ',' + valorFormatado.substring(8, 11);
    } else if (length === 11) {
      valorRetorno = valorFormatado.substring(0, 3) + '.' + valorFormatado.substring(3, 6) + '.' + valorFormatado.substring(6, 9) + ',' + valorFormatado.substring(9, 12);
    } else if (length === 12) {
      valorRetorno = valorFormatado.substring(0, 3) + '.' + valorFormatado.substring(3, 6) + '.' + valorFormatado.substring(6, 9) + ',' + valorFormatado.substring(9, 12);
    }
    return valorRetorno;
  };

  formataValorNegativo = (input, previousValue) => {
    var isNegativo = false;
    if (input !== '') {
      if (input === '-' || input.substring(0, 1) === '-') {
        isNegativo = true;
      }
    }
    if (!isNegativo) {
      return this.formataValor(input, previousValue);
    } else {
      input = input.substring(1, input.length);
      if (previousValue !== undefined && previousValue !== '') {
        previousValue = previousValue.substring(1, previousValue.length);
      }
      if ((previousValue !== undefined && previousValue !== '') && input === '') {
        return '';
      }
      if ((previousValue !== undefined && previousValue !== '') || input !== '') {
        return '-' + this.formataValor(input, previousValue);
      } else {
        return '-';
      }
    }
  };

  formataCEP (str) {
    var re = /^([\d]{2})\.?([\d]{3})-?([\d]{3})/;
    if (re.test(str)) {
      return str.replace(re, '$1.$2-$3');
    } else {
      return '';
    }
  }
  formataCepTextField = (input, previousValue) => {
    var valorRetorno;
    var valorFormatado = input.toString().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace('.', '').replace('-', '');
    var length = valorFormatado.length;
    var lengthAntes = previousValue ? previousValue.length : 0;

    if (length >= 8) {
      valorFormatado = valorFormatado.substring(0, 8);
      length = 8;
    }
    if (length === 1) {
      valorRetorno = valorFormatado;
    } else if (length === 2 && lengthAntes >= length) {
      valorRetorno = valorFormatado.substring(0, 2) + '.';
    } else if (length === 2 && lengthAntes < length) {
      valorRetorno = valorFormatado.substring(0, 2);
    } else if (length === 3) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 3);
    } else if (length === 4) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 4);
    } else if (length === 5 && lengthAntes >= length) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 5) + '-';
    } else if (length === 5 && lengthAntes < length) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 5);
    } else if (length === 6) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 5) + '-' + valorFormatado.substring(5, 6);
    } else if (length === 7) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 5) + '-' + valorFormatado.substring(5, 7);
    } else if (length === 8) {
      valorRetorno = valorFormatado.substring(0, 2) + '.' + valorFormatado.substring(2, 5) + '-' + valorFormatado.substring(5, 8);
    }
    return valorRetorno;
  };

  formataDDDTextField = (input, previousValue) => {
    var inputLen = String(input).length;
    var valorFormatado = input.toString().replace(/[^0-9.]/g, '').replace('(', '').replace(')', '');
    var valorRetorno = valorFormatado;
    var length = valorFormatado.length;
    var lengthAntes = previousValue ? previousValue.length : 0;

    if (length > 2) {
      valorFormatado = valorFormatado.substring(0, 2);
      valorRetorno = valorFormatado;
      length = 2;
    }
    if (length === 1) {
      valorRetorno = '(' + valorFormatado;
    } else if (length === 2 && inputLen > lengthAntes) {
      valorRetorno = '(' + valorFormatado.substring(0, 2) + ')';
    } else if (length === 2 && inputLen < lengthAntes) {
      valorRetorno = '(' + valorFormatado.substring(0, 2);
    }
    return valorRetorno;
  };
  formataTelefoneTextField = (input) => {
    var valorFormatado = input.toString().replace(/[^0-9.]/g, '').replace('-', '');
    var valorRetorno = valorFormatado;
    var length = valorFormatado.length;

    if (length >= 9) {
      valorFormatado = valorFormatado.substring(0, 9);
      length = 9;
    }
    if (length === 1) {
      valorRetorno = valorFormatado;
    } else if (length === 2) {
      valorRetorno = valorFormatado.substring(0, 2);
    } else if (length === 3) {
      valorRetorno = valorFormatado.substring(0, 3);
    } else if (length === 4) {
      valorRetorno = valorFormatado.substring(0, 4) + '-';
    } else if (length === 5) {
      valorRetorno = valorFormatado.substring(0, 4) + '-' + valorFormatado.substring(4, 5);
    } else if (length === 6) {
      valorRetorno = valorFormatado.substring(0, 4) + '-' + valorFormatado.substring(4, 6);
    } else if (length === 7) {
      valorRetorno = valorFormatado.substring(0, 4) + '-' + valorFormatado.substring(4, 7);
    } else if (length === 8) {
      valorRetorno = valorFormatado.substring(0, 4) + '-' + valorFormatado.substring(4, 8);
    } else if (length === 9) {
      valorRetorno = valorFormatado.substring(0, 5) + '-' + valorFormatado.substring(5, 9);
    }
    return valorRetorno;
  };


}

export default Utils;

export const getListaDatasReferencia = () => {
  // meses desde dataInicial
  let dataInicial = new Date(2013, 12, 1);
  let dataAtual = new Date();
  let resultado = [];
  while (isAfter(dataAtual, dataInicial)) {
    let registro = format(new Date(dataAtual), 'MM/YYYY');
    resultado.push(registro);
    dataAtual = subMonths(dataAtual, 1);
  }
  return resultado;
};
